import { CMTS_ROLE_CODES } from "./cmtsRoleCodes.js";

const LEGACY_ROLE_ALIASES: Readonly<Record<string, string>> = {
  ROLE_SYSTEM_ADMIN: CMTS_ROLE_CODES.SYSTEM_ADMIN,
  ROLE_TENANT_ADMIN: CMTS_ROLE_CODES.TENANT_ADMIN,
  ROLE_MANAGEMENT: CMTS_ROLE_CODES.MANAGEMENT,
  ROLE_QUALITY_HEAD: CMTS_ROLE_CODES.QUALITY_HEAD,
  ROLE_QUALITY_MANAGER: CMTS_ROLE_CODES.QUALITY_MANAGER,
  ROLE_DEPARTMENT_MANAGER: CMTS_ROLE_CODES.DEPARTMENT_MANAGER,
  ROLE_COMPLAINT_CREATOR: CMTS_ROLE_CODES.COMPLAINT_CREATOR,
  ROLE_INVESTIGATOR: CMTS_ROLE_CODES.INVESTIGATOR,
  ROLE_RCA_APPROVER: CMTS_ROLE_CODES.RCA_LEAD,
  ROLE_RCA_OWNER: CMTS_ROLE_CODES.RCA_LEAD,
  RCA_OWNER: CMTS_ROLE_CODES.RCA_LEAD,
  ROLE_CAPA_OWNER: CMTS_ROLE_CODES.CAPA_OWNER,
  ROLE_CAPA_VERIFIER: CMTS_ROLE_CODES.VERIFICATION_OWNER,
  VERIFIER: CMTS_ROLE_CODES.VERIFICATION_OWNER,
  ROLE_CUSTOMER_CONTACT: CMTS_ROLE_CODES.CUSTOMER_USER,
  CUSTOMER_EXTERNAL_USER: CMTS_ROLE_CODES.CUSTOMER_USER,
  ROLE_SUPPLIER_CONTACT: CMTS_ROLE_CODES.SUPPLIER_USER,
  SUPPLIER_EXTERNAL_USER: CMTS_ROLE_CODES.SUPPLIER_USER,
  ROLE_AUDITOR: CMTS_ROLE_CODES.AUDITOR,
  ROLE_REPORT_ANALYST: CMTS_ROLE_CODES.REPORT_MANAGER,
  ROLE_EVIDENCE_CONTROLLER: CMTS_ROLE_CODES.EVIDENCE_ADMIN,
  ROLE_SECURITY_REVIEWER: CMTS_ROLE_CODES.SECURITY_VIEWER,
};
const warnedAliases = new Set<string>();

export function normalizeCmtsRole(role: unknown): string | undefined {
  if (typeof role !== "string" || !role.trim()) return undefined;
  const code = role.trim().toUpperCase();
  if (LEGACY_ROLE_ALIASES[code] && !warnedAliases.has(code)) {
    warnedAliases.add(code);
    globalThis.console?.warn(`[CMTS_ROLE_ALIAS_DEPRECATED] ${code} was normalized to ${LEGACY_ROLE_ALIASES[code]}. Update the identity provider to emit canonical role codes.`);
  }
  return LEGACY_ROLE_ALIASES[code] ?? code;
}

export function normalizeCmtsRoles(roles: readonly unknown[] | null | undefined): string[] {
  return Array.from(new Set((roles ?? []).map(normalizeCmtsRole).filter((role): role is string => Boolean(role))));
}
